import React, { Component } from 'react';
import ComponentIcon from '@material-ui/icons/CheckBox';

class CheckSquareIcon extends Component {
  render() {
    return <ComponentIcon {...this.props} />;
  }
}

export default CheckSquareIcon;
